/* Complete the look — PDP bundle upsell.

   The safety rule this file exists to honour: a row is only addable once the
   shopper has resolved it to a real variant themselves. Size selects render
   empty (see snippets/complete-look-row.liquid) and nothing here ever fills one
   in. If you are tempted to auto-select a size to lift conversion, read the
   note in that snippet first — order #1001 is what that costs. */
(() => {
  const root = document.querySelector('[data-complete-look]');
  if (!root) return;

  const addBtn = root.querySelector('[data-complete-look-add]');
  const label = root.querySelector('[data-complete-look-label]');
  const errorEl = root.querySelector('[data-complete-look-error]');
  const rows = [...root.querySelectorAll('[data-cl-row]')];
  if (!rows.length || !addBtn) return;

  /* Format against the SHOP's money_format, not Intl.

     Intl with currency AUD renders "A$12.95" while the Liquid `money` filter on
     this store renders "$12.95" — mixing the two put both spellings in the same
     panel. Individual rows use the server-rendered `price_formatted`; only the
     running total is computed here, and it has to match. */
  const FORMAT = root.dataset.moneyFormat || '${{amount}}';

  const money = cents => {
    const withCommas = n =>
      n.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');

    return FORMAT.replace(/\{\{\s*(\w+)\s*\}\}/g, (_, token) => {
      switch (token) {
        case 'amount_no_decimals':
          return withCommas(Math.round(cents / 100));
        case 'amount_with_comma_separator':
          return withCommas(Math.floor(cents / 100)) + ',' + String(cents % 100).padStart(2, '0');
        case 'amount_no_decimals_with_comma_separator':
          return withCommas(Math.round(cents / 100));
        default: // amount
          return withCommas(Math.floor(cents / 100)) + '.' + String(cents % 100).padStart(2, '0');
      }
    });
  };

  const state = rows.map(row => {
    let variants = [];
    try {
      variants = JSON.parse(row.querySelector('[data-cl-variants]').textContent);
    } catch (e) {
      // A row we cannot parse is a row we must not offer.
      console.error('complete-look: bad variant JSON', e);
    }
    return {
      row,
      variants,
      selects: [...row.querySelectorAll('[data-cl-select]')],
      checkbox: row.querySelector('[data-cl-checkbox]'),
      priceEl: row.querySelector('[data-cl-price]'),
      imgEl: row.querySelector('[data-cl-img]'),
      noteEl: row.querySelector('[data-cl-note]'),
      variant: null
    };
  });

  /* Resolve the row against its selects. Returns null when any select is still
     empty (i.e. the shopper has not chosen a size yet) or when the chosen
     combination has no available variant. */
  function resolve(item) {
    if (!item.selects.length) return item.variants[0] || null;

    const chosen = item.selects.map(s => s.value);
    if (chosen.some(v => v === '')) return null;

    return item.variants.find(v =>
      v.options.length === chosen.length &&
      v.options.every((o, i) => o === chosen[i])
    ) || null;
  }

  function paint(item) {
    const v = resolve(item);
    item.variant = v;

    const sizeChosen = item.selects.every(s => s.value !== '');

    if (v) {
      // Prefer the server-rendered string so rows and the rest of the store
      // always spell money the same way.
      item.priceEl.textContent = v.price_formatted || money(v.price);
      if (v.image && item.imgEl) item.imgEl.src = v.image;
      item.noteEl.hidden = true;
      item.checkbox.disabled = false;
    } else {
      item.checkbox.checked = false;
      item.checkbox.disabled = true;
      // Only call it unavailable once they have actually picked everything —
      // an empty size select is not an error, it is the starting state.
      item.noteEl.hidden = !sizeChosen;
    }
  }

  function selected() {
    return state.filter(i => i.checkbox.checked && i.variant);
  }

  function paintFooter() {
    const picked = selected();
    const total = picked.reduce((sum, i) => sum + i.variant.price, 0);

    if (!picked.length) {
      addBtn.disabled = true;
      const anyResolvable = state.some(i => !i.checkbox.disabled);
      label.textContent = anyResolvable ? 'Select an item to add' : 'Select a size to add';
      return;
    }

    addBtn.disabled = false;
    label.textContent = `Add ${picked.length} item${picked.length > 1 ? 's' : ''} · ${money(total)}`;
  }

  state.forEach(item => {
    item.selects.forEach(sel =>
      sel.addEventListener('change', () => { paint(item); paintFooter(); })
    );
    item.checkbox.addEventListener('change', paintFooter);
    paint(item);
  });
  paintFooter();

  addBtn.addEventListener('click', async () => {
    const picked = selected();
    if (!picked.length) return;

    addBtn.disabled = true;
    errorEl.hidden = true;
    const previous = label.textContent;
    label.textContent = 'Adding…';

    try {
      await window.addItemsToCart(picked.map(i => ({ id: i.variant.id, quantity: 1 })));

      const cart = await window.fetchCart();
      window.updateCartCount(cart.item_count);
      // Repaint before opening so the drawer never flashes its empty state.
      await window.refreshCartDrawerDom();

      const drawer = document.getElementById('CartDrawer');
      if (drawer) {
        drawer.classList.add('is-open');
        drawer.setAttribute('aria-hidden', 'false');
        document.body.style.overflow = 'hidden';
      }

      // Clear the panel so the same bundle cannot be added twice by accident.
      picked.forEach(i => { i.checkbox.checked = false; });
      paintFooter();
    } catch (err) {
      console.error('complete-look add failed:', err);
      errorEl.textContent = 'Could not add those items. Please try again.';
      errorEl.hidden = false;
      label.textContent = previous;
      addBtn.disabled = false;
    }
  });
})();
